/**
 * The type scale — ONE set of font sizes for every surface (P3).
 *
 * A size name means the same size on the web and the phone: web `text-sm`
 * and phone `TYPOGRAPHY.size.sm` are both 14. (The phone used to run its own
 * scale one step down — its `xs` was 10 and its `sm` 12 — and most screens
 * set raw numbers besides, so the two apps drifted apart.)
 *
 * - Web: the Tailwind classes `text-2xs` … `text-6xl`. `2xs` is ours (declared
 *   in css/globals.css, pinned to this value by sizes.spec.ts); the rest are
 *   Tailwind's defaults, which these values equal.
 * - Phone: `TYPOGRAPHY.size` IS this object.
 * - Charts (SVG ticks) take the number: `fontSize: TYPE_SCALE.xs`.
 *
 * `2xs` (11) is the floor — micro-labels, eyebrows and badges. Nothing smaller
 * is readable; ESLint forbids arbitrary sizes on both apps.
 */
export const TYPE_SCALE = {
  '2xs': 11,
  xs: 12,
  sm: 14,
  base: 16,
  lg: 18,
  xl: 20,
  '2xl': 24,
  '3xl': 30,
  '4xl': 36,
  '5xl': 48,
  '6xl': 60,
} as const;

export type TypeScaleStep = keyof typeof TYPE_SCALE;
